export const LocalPath = {
  request_otp: "/auth/get_otp",
};

export const DevPath = {
  request_otp: "/auth/get_otp",
  verify_otp: "/auth/verify_otp",
  // Phone + password login. password_otp sends a WhatsApp code only for set/forgot password.
  login_password: "/auth/login_password",
  signup_password: "/auth/signup_password",
  password_otp: "/auth/password_otp",
  set_password: "/auth/set_password",
  store_details: "/store/open/details",
  store_details_refresh: "/store/open/details_refresh",
  store_visit: "/store/open/visit",
  store_location: "/store/open/location",
  store_data: "/store/open/all_store_products_filter",
  store_filter: "/store/open/filters",
  view_categories: "/store/open/all_hct_products",
  view_categories_new: "/store/open/all_store_products_by_hct",
  product_filters: "/store/open/product_filters",
  view_product_details: "/product/open/get_by_id",
  search_product_list: "/product/open/search",
  // Results grid for /search. `search_product_list` above is the autocomplete
  // dropdown — same feature, two endpoints, different payload sizes.
  store_search: "/store/open/search",
  // Reads the search_log table, so it errors until 116.sql is applied. Listed
  // anyway because the route exists and answers — the seam degrades to an empty
  // list, which is the same thing it will legitimately return for weeks after
  // the migration lands.
  search_popular: "/store/open/search/popular",
  search_log: "/store/open/search/log",
  get_cart_products: "/cart/open/get_cart",
  update_cart_quantity: "/cart/open/update_cart",
  delete_cart_product: "/cart/open/delete_cart",
  add_cart_products: "/cart/open/add",
  get_faqs: "/store/open/get_faqs",
  prc_to_cart: "/cart/convert_prsc_to_cart",
  co_to_cart: "/cart/open/convert_co_to_cart",
  get_prc_data: "/order/open/user_details_by_co_or_pres_no",
  cart_to_order: "/order/open/convert_cart_to_order",
  create_order: "/order/create_order",
  create_cart_order: "/order/open/create_order_from_cart",
  confirm_order: "/order/open/confirm_order",
  razorpay_checkout_data: "/order/open/razorpay_checkout_data",
  get_orders: "/order/all_orders",
  get_order_detail: "/order/open/order_details",
  get_order_detail_number: "/order/open/order_details_by_ord_number",
  get_cart_count: "/cart/open/get_cart_count",
  cancel_order: "/order/cancel_order",
  cancel_order_reasons: "/order/cancel_order_reasons",
  return_order_reasons: "/order/return_order_reasons",
  return_order: "order/return_order",
  add_to_wishlist: "/wishlist/add_to_wishlist",
  get_wishlist: "/wishlist/get_wishlist",
  delete_wishlist_item: "/wishlist/delete_wishlist",
  update_wishlist_quantity: "/wishlist/update_wishlist",
  add_wishlist_cart: "/wishlist/convert_to_cart",
  get_address: "/cart/get_shipping_address",
  save_address: "/cart/open/save_shipping_address",
  postal_codes: "/cart/open/pincode",
  del_save_address: "/cart/delete_shipping_address",
  pincode_check_availability: "/product/open/check_availability",
  get_order_payment_types: "/order/open/order_payment_types",
  payment_status_by_order_no: "/order/open/payment_status_by_order_no",
  new_mystore: "/store/open/all_health_concerns_by_category",
  get_health_concerns_by_category:
    "/store/open/get_health_concerns_by_category",
  best_sellers: "/store/open/featured_products?type=single",
  combo_pack: "/store/open/featured_products?type=combo",
  is_eligible: "/order/in_shop_return_eligibility",
  cancel_return_order_request: "/order/cancel_return_order_request",
  return_by_courier: "/order/return_order_by_courier",
  change_lang: "/store/switch_language",
  upload_custom_print_image: "/cart/open/upload_file",
  send_custom_images: "/cart/open/cart_images",
  cancel_return_order_request_v2:
    "/order/cancel_return_order_request_v2_orders",
  get_pinboard_data: "/dashboard/open/pin_boards",
  get_home_page: "/dashboard/open/get_home_page",
  notify_me: "/product/open/save_product_notify_user",
  notify_me_cart: "/cart/open/save_notify_user",
  rehold_cart: "/cart/open/rehold-reservation",
  // Win-back offer: mints a per-customer, auto-applied 5% platform coupon after the server
  // re-verifies that the product really is held by someone else. Authenticated (no "open/") --
  // the coupon is bound to one customer and needs their phone.
  similar_products_offer: "/similar-products/offer",
  // Guest twin of the above (public, "open/"): a guest's coupon is bound to their session
  // instead of a phone, so a guest is not bounced by the auth filter.
  similar_products_offer_open: "/similar-products/open/offer",
  // Substitutes rail. Caller appends /{productId}, same convention as
  // view_product_details above. Public: the "*/open/**" whitelist needs one segment before
  // "/open/", which is why the path is /similar-products/open/... and not /open/...
  // Nothing calls this from the UI yet -- the "shop similar" flows navigate to the /shop
  // listing ROUTE rather than fetching this -- but it is reachable and returns 200.
  similar_products_list: "/similar-products/open/list",
  // Festival page (<store>/<slug>). Without a slug it answers "this store's page, whatever it
  // is"; with one it also says whether the slug is a real festival at all (404 vs "ended").
  offer_page: "/store/open/offer_page",
  offer_page_colour: "/store/open/offer_page/colour",
  apply_coupon: "/cart/open/apply_coupon",
  remove_coupon: "/cart/open/remove_coupon",
  // Seller-funded coupon shares apply_coupon's single input (auto-detected server-side) but has
  // its own remove action, since it stacks independently with the platform coupon.
  remove_seller_coupon: "/cart/open/remove_seller_coupon",
  connect_presence: "/reservations/open/connect_presence",
  heartbeat_presence: "/reservations/open/heartbeat_presence",
  disconnect_presence: "/reservations/open/disconnect_presence",
  about_me: "/store/open/about_me",
  // Cart-recovery email opt-out; token from the email's /email/unsubscribe?t= link. Idempotent.
  email_unsubscribe: "/store/open/email/unsubscribe",
  save_consent: "/dashboard/open/save_consent",
  get_consent: "/dashboard/open/get_consent",

  nav_drawer: "/store/open/nav_drawer",
  get_reviews: "/order/open/get_reviews",
  get_rating_form: "/order/get_rating_form",
  submit_rating: "/order/submit_rating",

  // Shop By craft
  fashion_sub_categories: "/craft/open/fashion_sub_categories",
  craft_by_id: "/craft/open/details/{craftId}",
  crafts_by_fashion_sub_category:
    "/craft/open/by_sub_category/{fashionSubCatId}",
  filters_by_craft_id: "/craft/open/filters/{craftId}",

  craft_open_journal: "/craft/open/journal",

  craft_open_journal_categories: "/craft/open/journal/categories",

  craft_open_journal_article: "/craft/open/journal/article/{knowYourCraftId}",

  craft_open_behind_the_scenes: "craft/open/behind_the_scenes",

  craft_open_behind_the_scenes_categories:
    "craft/open/behind_the_scenes/categories",

  craft_open_verified_handloom_filters: "craft/open/verified_handloom/filters",

  craft_open_verified_handloom: "craft/open/verified_handloom",
};
const env = process.env.REACT_APP_ENV || "local";
export const Paths = (() => {
  switch (env) {
    case "local":
      return LocalPath;
    case "development":
    default:
      return DevPath;
  }
})();
